<template>
  <div class="LFwrapper">
    <select>
      <option>추천순</option>
      <option>등록순</option>
      <option>별점순</option>
      <option>연관순</option>
    </select>
    <div class="filterbox">
      <div class="header">분야별</div>
      <div class="body">
        <div class="filter">
          <input type="checkbox" id="filter1" />
          <label for="filter1">분야1</label>
        </div>
        <div class="filter">
          <input type="checkbox" id="filter2" />
          <label for="filter2">분야2</label>
        </div>
        <div class="filter">
          <input type="checkbox" id="filter3" />
          <label for="filter3">분야3</label>
        </div>
      </div>
      <div class="header">로드맵</div>
      <div class="body">
        <div class="filter">
          <input type="checkbox" id="filter3" />
          <label for="filter3">로드맵1</label>
        </div>
      </div>
    </div>
    <div class="reset">필터 초기화</div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.LFwrapper {
  @extend .sidebar-wrapper;
}

select {
  height: 44px;
  border-radius: 4px;
  width: 100%;
  border-color: $gray200;
  padding: 10px;
}

.filterbox {
  margin-top: 25px;
  border-radius: 4px;
  border: 1px solid $gray200;
  .header {
    height: 45px;
    background-color: $gray200;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .body {
    padding: 20px 10px 20px 10px;
    display: flex;
    flex-direction: column;
    .filter {
      color: $gray500;
      font-size: 1em;
      input {
        margin-right: 10px;
      }
      label {
        margin-bottom: 0;
      }
    }
  }
}
</style>